import { ensureItemsModalState } from './state.js';

export function handleItemsListClick(event) {
    const removeBtn = event.target.closest('.remove-item-btn');
    if (!removeBtn) {
        return;
    }

    const fdiId = removeBtn.dataset.fdiId;
    if (!fdiId || !this.currentCollectionId) {
        return;
    }

    this.removeItemFromCollection(fdiId, this.currentCollectionId, removeBtn);
}

export function handleItemsListChange(event) {
    const checkbox = event.target.closest('.item-checkbox');
    if (!checkbox) {
        return;
    }

    const state = ensureItemsModalState(this);
    const fdiId = checkbox.dataset.fdiId;

    if (!fdiId) {
        return;
    }

    if (checkbox.checked) {
        state.selectedIds.add(fdiId);
    } else {
        state.selectedIds.delete(fdiId);
    }

    this.toggleBulkActionsHeader();
}

export function handleSelectAllItems(event) {
    const selectAll = event.target;
    const state = ensureItemsModalState(this);
    const shouldSelect = Boolean(selectAll?.checked);

    state.cachedElements.forEach(({ element, fdiId }) => {
        if (element.classList.contains('hidden')) {
            return;
        }

        const checkbox = element.querySelector('.item-checkbox');
        if (!checkbox) {
            return;
        }

        checkbox.checked = shouldSelect;
        if (shouldSelect) {
            state.selectedIds.add(fdiId);
        } else {
            state.selectedIds.delete(fdiId);
        }
    });

    this.toggleBulkActionsHeader();
}

